import React from 'react';

interface CellarEdgeLogoProps {
  width?: number;
  height?: number;
}

const CellarEdgeLogo: React.FC<CellarEdgeLogoProps> = ({ width = 200, height = 66 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 300 100"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'block' }}
    >
      <defs>
        <linearGradient id="wineGradient" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" style={{ stopColor: '#8B0000', stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: '#4A0E0E', stopOpacity: 1 }} />
        </linearGradient>
        <linearGradient id="edgeGradient" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" style={{ stopColor: '#C0392B', stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: '#E74C3C', stopOpacity: 1 }} />
        </linearGradient>
      </defs>

      {/* Simple wine glass outline */}
      <path
        d="M30 20 Q30 30 35 40 Q40 50 40 60 L40 70 L37 70 L37 75 L47 75 L47 70 L44 70 L44 60 Q44 50 49 40 Q54 30 54 20 Z"
        fill="none"
        stroke="#2C3E50"
        strokeWidth="2.5"
      />

      {/* Wine in glass */}
      <path
        d="M32 25 Q32 33 36 41 Q39 47 39 57 L39 68 L45 68 L45 57 Q45 47 48 41 Q52 33 52 25 Z"
        fill="url(#wineGradient)"
      />

      {/* Sharp angular "edge" element */}
      <polygon points="65,35 85,25 90,30 70,40" fill="url(#edgeGradient)"/>
      <polygon points="65,35 85,25 87,26 67,36" fill="#FFFFFF" opacity="0.4"/>

      {/* Clean trend arrow */}
      <path
        d="M75 50 L95 40 L90 37 M95 40 L92 45"
        stroke="#27AE60"
        strokeWidth="2.5"
        fill="none"
        strokeLinecap="round"
      />

      {/* Company name */}
      <text x="110" y="40" fontFamily="Arial, sans-serif" fontSize="22" fontWeight="bold" fill="#2C3E50">
        CELLAR
      </text>
      <text x="110" y="62" fontFamily="Arial, sans-serif" fontSize="22" fontWeight="300" fill="#C0392B">
        EDGE
      </text>

      {/* Tagline */}
      <text x="110" y="78" fontFamily="Arial, sans-serif" fontSize="10" fill="#7F8C8D">
        Wine Market Analysis
      </text>
    </svg>
  );
};

export default CellarEdgeLogo;
